<script>
    import AuthCard from "../shared/AuthCard.svelte";
    import Label from "../shared/Label.svelte";
    import {translations} from "../../../stores/translations";
    import Button from "../shared/Button.svelte";
    import Input from "../shared/Input.svelte";
    import {AuthResource} from "../../../Api/resources/AuthResource";
    import {Navigate, navigateTo} from "svelte-router-spa";

    const authResource = new AuthResource();

    let email = '';
    let isRedirecting = false;

    function requestResetPasswordEmail() {
		if(isRedirecting){
			return;
		}

        isRedirecting = true;
        authResource
            .requestForgottenPassword(email)
            .then((response) => {
                alert(response.data.status);
                navigateTo('login');
            })
            .catch((error) => {
                alert(error.response.data.message);
            }).finally(() => {
            isRedirecting = false;
        });
    }
</script>

<AuthCard>
    <div class="mb-4 font-medium text-lg text-white text-center leading-6">
        {@html $translations.login_restore_title}
    </div>

	<form on:submit|preventDefault={requestResetPasswordEmail}>
		<!-- Email Address -->
		<div class="flex flex-row mt-5">
			<div class="w-1/4">
				<Label name="email">{$translations.login_email}</Label>
			</div>
			<div class="w-3/4">
				<Input type="email" name="email" bind:value={email}/>
			</div>
		</div>

		<div class="flex flex-row mt-4">
			<div class="w-1/4"></div>
			<div class="w-3/4">
				<Button class="relative" type="submit" on:click={requestResetPasswordEmail} disabled={isRedirecting}>
					<img alt="" class="spinner w-5 h-5 absolute left-2" class:opacity-0={!isRedirecting}
						 src="{$translations.login_preloader}">
					{$translations.login_get_pw}
				</Button>
			</div>
		</div>
	</form>

    <div class="flex flex-row justify-between mt-8 text-white">
        <div class="leading-5">
            {@html $translations.user_profile_footer}
        </div>

        <div class="flex items-end justify-end mt-4">
            <Navigate styles="text-xs text-white hover:text-gray-200" to="/login">
                {$translations.login_back}
            </Navigate>
        </div>
    </div>
</AuthCard>
